import type { SVGProps } from "react"

// Ícones inline da tela de vendas — traço 1.5, fiéis ao protótipo.
// Não substituir por lucide: pix/barcode/maple/gift não existem lá e o
// admin salva `features[].icon` com estes nomes.

type P = SVGProps<SVGSVGElement>

export const SalesIcon = {
  play: (p: P) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M8 5l12 7-12 7z" />
    </svg>
  ),
  check: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M3 8.5l3 3 7-7" />
    </svg>
  ),
  arrow: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M4 10h12M11 5l5 5-5 5" />
    </svg>
  ),
  chevron: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M5 6.5l3 3 3-3" />
    </svg>
  ),
  shield: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M8 1.5l5.5 2v4c0 3.5-2.3 6-5.5 7-3.2-1-5.5-3.5-5.5-7v-4z" />
      <path d="M5.6 8l1.8 1.8L10.5 6.6" />
    </svg>
  ),
  gift: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="2" y="6" width="12" height="3" rx="0.5" />
      <path d="M3 9v5h10V9M8 6v8" />
      <path d="M8 6S6 2 4.5 2.5 5 6 8 6zM8 6s2-4 3.5-3.5S11 6 8 6z" />
    </svg>
  ),
  star: (p: P) => (
    <svg viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M8 1l2.2 4.6L15 6.3l-3.6 3.4L12.3 15 8 12.5 3.7 15l1-5.3L1 6.3l4.8-.7z" />
    </svg>
  ),
  flame: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M10 2c2.5 3 5 4.8 5 8a5 5 0 0 1-10 0c0-1.6.8-2.8 1.8-4 .3 1 1 1.6 1.7 1.6C10 7.6 8.5 5 10 2z" />
    </svg>
  ),
  mic: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="7.5" y="2.5" width="5" height="9" rx="2.5" />
      <path d="M4.5 9.5a5.5 5.5 0 0 0 11 0M10 15v2.5M7 17.5h6" />
    </svg>
  ),
  pen: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M13.5 2.5l4 4L7 17H3v-4z" />
      <path d="M11.5 4.5l4 4" />
    </svg>
  ),
  live: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="2" y="4" width="12" height="12" rx="2.5" />
      <path d="M14 9l4-2.5v7L14 11z" />
    </svg>
  ),
  route: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <circle cx="5" cy="5" r="2.5" />
      <circle cx="15" cy="15" r="2.5" />
      <path d="M5 7.5v3a3 3 0 0 0 3 3h4.5" />
    </svg>
  ),
  target: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <circle cx="10" cy="10" r="7" />
      <circle cx="10" cy="10" r="3" />
      <path d="M10 1v2M10 17v2M1 10h2M17 10h2" />
    </svg>
  ),
  users: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <circle cx="7.5" cy="7" r="3" />
      <path d="M2.5 17c0-3 2.2-5 5-5s5 2 5 5" />
      <circle cx="14.5" cy="7.5" r="2.3" />
      <path d="M14 12.5c2.4 0 4 1.7 4 4" />
    </svg>
  ),
  file: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M9 1.5H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.5z" />
      <path d="M9 1.5v4h4" />
    </svg>
  ),
  calendar: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...p}
    >
      <rect x="2" y="3.5" width="12" height="10.5" rx="1.5" />
      <path d="M2 6.5h12M5.5 2v2.5M10.5 2v2.5" />
    </svg>
  ),
  card: (p: P) => (
    <svg
      viewBox="0 0 24 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      {...p}
    >
      <rect x="1.5" y="2" width="21" height="12.5" rx="2" />
      <path d="M1.5 6h21" strokeWidth="2.2" />
      <path d="M5 10.5h3" />
    </svg>
  ),
  pix: (p: P) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
      {...p}
    >
      <path d="M7 3.8l-3.2 3.2a1 1 0 0 0 0 1.4L7 11.6M13 3.8l3.2 3.2a1 1 0 0 1 0 1.4L13 11.6" />
      <path d="M8.3 12.9l1 1a1 1 0 0 0 1.4 0l1-1M8.3 5.9l1-1a1 1 0 0 1 1.4 0l1 1" />
    </svg>
  ),
  barcode: (p: P) => (
    <svg viewBox="0 0 24 16" fill="currentColor" {...p}>
      <rect x="2" y="2" width="1.4" height="12" />
      <rect x="5" y="2" width="2.4" height="12" />
      <rect x="9" y="2" width="1.4" height="12" />
      <rect x="12" y="2" width="3" height="12" />
      <rect x="16.5" y="2" width="1.4" height="12" />
      <rect x="20" y="2" width="2" height="12" />
    </svg>
  ),
  lock: (p: P) => (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      {...p}
    >
      <rect x="3" y="7" width="10" height="7" rx="1.5" />
      <path d="M5 7V5a3 3 0 0 1 6 0v2" />
    </svg>
  ),
  maple: (p: P) => (
    <svg viewBox="0 0 16 16" fill="currentColor" {...p}>
      <path d="M8 1.2l1 2.6 1.9-.9-.5 2.2 2.3-.3-1.3 1.8 2.1.9-2 1.1.9 1.5-2.3-.2.3 2.1L8 10.9l-2.4 1.1.3-2.1-2.3.2.9-1.5-2-1.1 2.1-.9L3.3 4.8l2.3.3-.5-2.2 1.9.9z" />
    </svg>
  ),
} satisfies Record<string, (p: P) => React.JSX.Element>

export type SalesIconName = keyof typeof SalesIcon

/** Renderiza `features[].icon`/ícones de método com fallback seguro. */
export function IconGlyph({
  name,
  ...props
}: { name: string | undefined } & P) {
  const Icon = SalesIcon[(name ?? "") as SalesIconName] ?? SalesIcon.check
  return <Icon {...props} />
}
